import React, { useContext, useEffect, useState } from "react";
import { Fetchdata } from "../../hooks/getData";
import SidebarContext from "../../sidebarcontext/SidebarContext";
import { toast } from "react-toastify";
import LeaveApplicationContext from "./LeaveApplicationContext";

function LeaveApplicationState(props) {
  const { appURL, getEnglishDate } = useContext(SidebarContext);

  const [loading, setLoading] = useState(true);
  const [originalList, setOriginalList] = useState(null);

  const userinfo = JSON.parse(localStorage.getItem("userInfo"));

  const leaveValue = {
    title: "",
    description: "",
    fromDate: getEnglishDate,
    toDate: "",
  };
  const [leaveFormValue, setLeaveFormValue] = useState(leaveValue);
  const [leaveFormError, setLeaveFormError] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const [popup, setPopup] = useState(false);
  const togglePopup = () => {
    setPopup(!popup);
  };

  // To set two dates to two variables
  var date1 = new Date(leaveFormValue.fromDate);
  var date2 = new Date(leaveFormValue.toDate);

  // To calculate the time difference of two dates
  var Difference_In_Time = date2.getTime() - date1.getTime();

  // To calculate the no. of days between two dates
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

  //API to create leave list
  const fetchdata = () => {
    const dataForm = {
      SchID: userinfo.SchID,
      Flag: "i",
      DFlag: "E",
      MemID: userinfo.UserID,
      UserType: userinfo.UserType,
      Title: leaveFormValue.title,
      Description: leaveFormValue.description,
      From: leaveFormValue.fromDate,
      To: leaveFormValue.toDate,
      NoOfDays: Difference_In_Days.toString(),
      Academicyear: userinfo.AcademicYear,
      FetchURL: `${appURL}api/leave`,
      Type: "POST",
    };

    Fetchdata(dataForm).then(function (result) {
      if (result.StatusCode === 200) {
        getLeaveApplicationList();
        toast(result.Message, {
          style: {
            color: "green",
            fontSize: "13px",
          },
        });
      } else {
        toast("Error: " + result.Message, {
          style: {
            color: "red",
            fontSize: "13px",
          },
        });
      }
    });
  };

  // API for leavelist
  const [leaveList, setLeaveList] = useState([]);

  useEffect(() => {
    getLeaveApplicationList();
  }, []);

  const getLeaveApplicationList = () => {
    const params = {
      SchID: userinfo.SchID,
      MemID: userinfo.UserID,
      Flag: "S",
      DFlag: "E",
      Type: "POST",
      Academicyear: userinfo.AcademicYear,
      FetchURL: `${appURL}api/leave`,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.LeaveLst ? result.LeaveLst : "";

        setLoading(false);
        setLeaveList(postResult);
        setOriginalList(postResult);
      } else {
        setLoading(false);
        setLeaveList([]);
        setOriginalList([]);
      }
    });
  };

  //Everything to pop up and delete the event list
  const [deletePopup, setDeletePopup] = useState({
    show: false, // initial values set to false and null
    data: null,
  });

  const [delData, setDelData] = useState();

  const handleDelete = async (data) => {
    setDelData(data);

    setDeletePopup({
      show: true,
      data,
    });
  };

  // This will perform the deletion and hide the Confirmation Box

  const handleDeleteTrue = async () => {
    const dataForm = {
      SchID: userinfo.SchID,
      MemID: userinfo.UserID.toString(),
      Flag: "R",
      LeaveID: delData.toString(),
    };

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dataForm),
    };
    fetch(`${appURL}api/leave`, requestOptions).then((result) => {
      result.json().then((resp) => {
        if (resp.StatusCode === 200) {
          getLeaveApplicationList();
          toast(resp.Message, {
            style: {
              color: "green",
              fontSize: "13px",
            },
          });
        } else {
          toast(resp.Message, {
            style: {
              color: "red",
              fontSize: "13px",
            },
          });
        }
      });
    });
    setDeletePopup({
      show: false,
      data: null,
    });
  };

  // This will just hide the Confirmation Box when user clicks "No"/"Cancel"

  const handleDeleteFalse = () => {
    setDeletePopup({
      show: false,
      data: null,
    });
  };

  // Ends Here

  return (
    <LeaveApplicationContext.Provider
      value={{
        loading,
        originalList,
        deletePopup,
        handleDeleteTrue,
        handleDeleteFalse,
        handleDelete,
        popup,
        setPopup,
        togglePopup,
        leaveFormValue,
        setLeaveFormValue,
        leaveFormError,
        setLeaveFormError,
        isSubmit,
        leaveValue,
        setIsSubmit,
        setLeaveList,
        fetchdata,
        leaveList,
        getLeaveApplicationList,
      }}
    >
      {props.children}
    </LeaveApplicationContext.Provider>
  );
}

export default LeaveApplicationState;
